export { default as getTranslation } from './getTranslation';
export { default as t } from './t';
